import { gql } from '@apollo/client'

/**
 * GraphQL Mutation Delete Payee.
 * @function DELETE_PAYEES_MUTATION
 * Returns the GraphQL mutation string (e.g. `mutation deletePayee { payeeId, payeeStatus }`).
 * @return {payeeId, payeeStatus} response data.
 */
/* E.g. variables: {
    "appName": "BILLPAY",
    "payeeDeleteRequest": {
     "payeeId": "d2971b06-7bd9-4abc-a91e-25c64606d5d8"
    }
} */

export const DELETE_PAYEES_MUTATION = gql`
  mutation deleteBillpayPayee(
    $appName: AppNameEnum
    $payeeDeleteRequest: BillpayPayeeDeleteRequest!
  ) {
    deleteBillpayPayee(
      appName: $appName
      payeeDeleteRequest: $payeeDeleteRequest
    ) {
      payeeId
      payeeStatus
    }
  }
`
export default DELETE_PAYEES_MUTATION
